<!-- Search.svelte -->
<script>
  export let autofocus = false;
  export let characters = [];

  import { onMount } from "svelte";

  let input = undefined;
  let value = "";

 onMount(() => {
    if (autofocus) {
      input.focus();
    }
  });

  $: filtered = characters.filter((item) =>
    item.toLowerCase().includes(value.toLowerCase())
  );
</script>

<style>
  ul {
    list-style: none;
  }
</style>

<input bind:this="{input}" type="search" bind:value />

<ul>
  {#each characters as item}
  <li>{item}</li>
  {/each}
</ul>
